import React, { useLayoutEffect, useRef } from 'react';
import type { GlueIntegration } from '@glueapp/graph-types';
import { usePortPositions } from '@/GraphEditor/drawingLayer/contexts/PortPositionsContext';
import { usePortOverlayNode } from '@/GraphEditor/drawingLayer/contexts/PortOverlayNodeContext';

interface Props {
    integration: GlueIntegration<any>;
}

export const IntegrationMarker: React.FC<Props> = ({ integration }) => {
    const { openOverlay } = usePortOverlayNode();
    const markerRef = useRef<HTMLSpanElement>(null);
    const { setInPortPosition } = usePortPositions();

    useLayoutEffect(() => {
        const el = markerRef.current;
        if (el) {
            const nodeContainer = el.closest('[data-node-container]') as HTMLElement | null;
            const rect = el.getBoundingClientRect();
            setInPortPosition('__integration__', {
                x: nodeContainer ? nodeContainer.getBoundingClientRect().left : rect.left,
                y: rect.y + rect.height / 2,
            });
        }
    });

    const handlePointerDown = (e: React.PointerEvent) => {
        e.stopPropagation();
        e.preventDefault();
        openOverlay('__integration__', 'special');
    };

    return (
        <span
            ref={markerRef}
            onPointerDown={handlePointerDown}
            className="inline-flex items-center gap-1 px-1.5 py-0.5 text-xs rounded cursor-pointer hover:opacity-80 transition-opacity"
            style={{ color: 'inherit', opacity: 0.7 }}
        >
            {integration.provider}
        </span>
    );
};
